import React from 'react'
import BgimageTestRight from '../../components/others/callToActionText/bgimageTestRight'
import HeroImage from '../../images/sellonkay.jpg'
import Tright from '../../components/others/textImage/tright'
import Tleft from '../../components/others/textImage/tleft'
import StoryImage from '../../images/about/Target.jpg'
import CommunityImage from '../../images/about/Target.jpg'
import DocumentMeta from 'react-document-meta';

const Sellonkaay = () => {
  const meta = {
    /*title: 'New Arrivals | Latest & trendy Products on KAAY',
    description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
    */
    canonical: window.location.href
    /*canonical: 'http://example.com/path/to/page',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }
  return (
    <div>
    <DocumentMeta {...meta} />
      <BgimageTestRight 
        Image={HeroImage} 
        H1="BUY. SELL."
        H2="DO IT ALL OVER." 
        P="Welcome to the community-powered circular fashion marketplace." 
        BURL="/collection"
        BText="Shop now"
      />
      <div>
        <Tright Title="How to sell" Message={["It’s easy to get started – just create an account to start selling. Take up to four photos. Describe what you’re selling. Decide your price. Get paid fast when your item sells. Ship. Repeat."]} Image = {CommunityImage} Class = 'light'/>
      </div>
      <div>
        <Tleft Title="How to sell" Message={["It’s easy to get started – just create an account to start selling. Take up to four photos. Describe what you’re selling. Decide your price. Get paid fast when your item sells. Ship. Repeat."]} Image = {StoryImage} Class = 'light'/>
      </div>
    </div>
  )
}

export default Sellonkaay
